// External libraries
import React from 'react';
import { useStoreState } from '@/store';
//@ts-expect-error untyped import
import { CardCvv as Cvv } from '@checkout/react-components';

// Internal modules
import {
  cardSubFieldsContainerStyleOverrides,
  cvvIconStyleOverrides,
} from '../styles';
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { cardTypeChangeHandler } from './handlers';
import { formInputHandlers } from '@/components/Form/formInputHandlers';

export const CardCvv = (): React.ReactElement => {
  useMountLogging('CardCvv');
  const cardCvv = useStoreState(({ form }) => form.cardCvv);
  const { cardType } = useStoreState(({ form }) => form.cardNumber);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const ariaContentKey = cardType === 'AMEX' ? 'amex' : 'base';
  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <Cvv
      ariaDescribedByContent={getContent(`accessibility.cvv.${ariaContentKey}`)}
      cardType={cardType}
      containerStyleOverrides={cardSubFieldsContainerStyleOverrides}
      cvvIconStyleOverrides={cvvIconStyleOverrides}
      disabled={isFormSubmitting}
      iconPosition="right"
      label={getContent('fieldLabels.cvv')}
      onAfterCardTypeChange={cardTypeChangeHandler}
      theme={theme}
      {...formInputHandlers}
      {...cardCvv}
    />
  );
};
